import config from "@Config/index";
import { AppThunk } from "@Store/index";
import axios from "axios";
import {
  getBookingDetailsRequesting,
  getBookingDetailsSuccess,
  getBookingDetailsFailure,
} from "./bookingDetailsReducer";

const fetchBookingDetails =
  ({ inventoryId, token }: { inventoryId: string; token?: string }): AppThunk =>
  async (dispatch) => {
    dispatch(getBookingDetailsRequesting({ inventoryId }));

    const urlPath = "api/v1/auth/users/booking_detail";
    console.log("token", token);

    try {
      const response = await axios.get(`${config.API_URL}/${urlPath}`, {
        params: { inventory_id: inventoryId, ...(token ? { user_auth_token: token } : {}) },
        withCredentials: true,
      });

      dispatch(getBookingDetailsSuccess({ data: response.data?.data }));
      return null;
    } catch (err: any) {
      return dispatch(getBookingDetailsFailure(err?.message || err));
    }
  };

export default fetchBookingDetails;
